import React,{useState,useEffect } from "react";
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, } from 'mdb-react-ui-kit';
import {BiCloudUpload, BiUser} from "react-icons/bi";
import { AiOutlinePoweroff} from "react-icons/ai";
import { MdManageSearch } from "react-icons/md";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import jwtDecode from "jwt-decode";

const MFADashboardPage = () =>{
  const [role, setRole]= useState()
  const navigate = useNavigate();  
   const [session, setSession] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const[cogusername,SetCogUsername]=useState()


  useEffect(() => {
  const fetchTokens = async () => {
    if(!code){
      sessionStorage.setItem("sessioncode", " ")
      navigate('/');
      }else{
        sessionStorage.setItem("sessioncode", code)
      }
    //const sessioncode = sessionStorage.getItem("sessioncode")
       
    //console.log(sessioncode)
 const group=sessionStorage.getItem("group" )
    setRole(group)
    // Exchange authorization code for tokens
    if(!group){
    // Exchange authorization code for tokens
    try {
      const response = await axios.post('https://eu-west-1qktbytdgu.auth.eu-west-1.amazoncognito.com/oauth2/token', new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: 'jm03olh8l8cu404dq2t1qkjn2',
        client_secret: '1levtaqd977nn28uh4assec7t28ufecstnqs2beflusl55tjo07d',
        // client_id: 'l3b2no3q8178psocdvfbnkcke',
        // client_secret: '13d5bb0jmvrhg101dvj4h5fah98jt90rk6rsrqu7fnkodg5nq5fv',
        code: code,
        redirect_uri: 'https://wns-sentry-dev.sony.eu/dashboard'
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
        //console.log(response.data)

      //const { access_token, id_token, refresh_token } = response.data;
      const access_token = response.data.access_token
      const id_token = response.data.id_token
      const refresh_token = response.data.refresh_token
      //console.log(access_token)
      setSession({ access_token, id_token, refresh_token });

      const userGroup = await getUserGroupsFromToken(access_token);
      const userName = await getUserNamesFromToken(access_token);
      //console.log('User Groups:', userGroup[0]);
      sessionStorage.setItem("group",userGroup[0] )
      //console.log('User Groups:', userGroup[0]);
      sessionStorage.setItem("user",userName )
      SetCogUsername(userName)
      setRole(userGroup[0])

    } catch (error) {
      console.error('Error exchanging code for tokens:', error);
    }
    }

  sessionStorage.setItem("access_token",session && session.access_token)
  sessionStorage.setItem("id_token",session && session.id_token)
  sessionStorage.setItem("refresh_token",session && session.refresh_token)
 
}; 
fetchTokens();
}, [code, session, navigate]);

const getUserGroupsFromToken = async(accessToken) => {
  try {
    // Decode the access token
    const decodedToken = await jwtDecode(accessToken);
    //console.log('Decoded Token:', decodedToken);
    // Extract user groups
    const userGroups = await decodedToken['cognito:groups'] || [];
    return userGroups;
  } catch (error) {
    console.error('Error decoding token:', error);
    return [];
  }
};

const getUserNamesFromToken = async(accessToken) => {
  try {
    // Decode the access token
    const decodedToken = await jwtDecode(accessToken);
    //console.log('Decoded Token:', decodedToken);
    // Extract user groups
    const username = await decodedToken['username'] || "";
    return username;
  } catch (error) {
    console.error('Error decoding token:', error);
    return [];
  }
};


  const handleSignOut = () => {
    const clientId = 'jm03olh8l8cu404dq2t1qkjn2';
    const domain = 'eu-west-1qktbytdgu.auth.eu-west-1.amazoncognito.com'; // e.g., myapp.auth.us-west-2.amazoncognito.com
    const redirectUri = 'https://wns-sentry-dev.sony.eu/'; // Replace with your redirect URI

    // Construct the logout URL
    const logoutUrl = `https://${domain}/logout?client_id=${clientId}&logout_uri=${redirectUri}`;
    
    // Clear local and session storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Redirect to the Cognito logout URL
    window.location.href = logoutUrl;
  };

  const handleuploadNavigate = () => {
    window.open('/uploadcsv', '_blank'); // Open in a new tab
  };
  const handleauditorNavigate = () => {
    window.open('/audit', '_blank'); // Open in a new tab
  };
  const handlereviewNavigate = () => {
    window.open('/report', '_blank'); // Open in a new tab
  };

    return(
<>
<MDBContainer fluid className='dashboard vh  background-radial-gradient overflow-hidden'>
    <MDBContainer>
      <MDBRow>
        <MDBCol className="text-center" style={{color:"white"}}>
          <h2>Welcome To Sentry</h2>
          {role === "admin" ? "You have login as Admin" :  role === "dm"  ? "You have login as Data Manager"  : role === "auditor" ? "You have login as auditor" : role === "superadmin" ? "You have login as superadmin" : role === "report" ? "You have login as Reviewer" :  "" } <span style={{color:"#9e8aa5", marginLeft:"8px"}}> | </span><button onClick={handleSignOut} title ="Logout" style={{ width: 'auto', height: 'auto', background:"transparent", fontWeight:"400", color:"#fff", padding:"0 5px", border:"0px none" }}><AiOutlinePoweroff /> Logout</button>
        </MDBCol>
        </MDBRow>
      <MDBRow  className='position-relative'>
{role === "superadmin" ? 
<>
          <MDBCol md="1"></MDBCol>
          <MDBCol>  
            <MDBCard className='my-5 bg-glass text-center'>
            <MDBCardBody className='p-5'>
              <BiCloudUpload style={{ width: '60px', height: '60px', background:"", color:"rgb(120 54 157)", padding:"12px" }} className='rounded-circle'/><br/>
           Data Manager<br/><br/>
             <button onClick={handleuploadNavigate}  className="btn btn-primary">View </button>
            </MDBCardBody>
            </MDBCard>
          </MDBCol>
          
          <MDBCol>
            <MDBCard className='my-5 bg-glass text-center'>
              <MDBCardBody className='p-5'>
              <MdManageSearch style={{ width: '60px', height: '60px', background:"", color:"rgb(120 54 157)", padding:"12px" }} className='rounded-circle'/><br/>
              Auditor<br/><br/>
               <button onClick={handleauditorNavigate}  className="btn btn-primary">View </button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
          <MDBCard className='my-5 bg-glass text-center'>
            <MDBCardBody className='p-5'>
            <BiUser style={{ width: '60px', height: '60px', background:"", color:"#2d446c", padding:"12px" }} className='rounded-circle'/><br/>
             Reviewer<br/><br/>
             <button onClick={handlereviewNavigate}  className="btn btn-primary">View </button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>

        <MDBCol md="1"></MDBCol></>
: ""}
{role === "admin" ? 
<>
          <MDBCol md="1"></MDBCol>
          <MDBCol>  
            <MDBCard className='my-5 bg-glass text-center'>
            <MDBCardBody className='p-5'>
              <BiCloudUpload style={{ width: '60px', height: '60px', background:"", color:"rgb(120 54 157)", padding:"12px" }} className='rounded-circle'/><br/>
           Data Manager<br/><br/>
             <button onClick={handleuploadNavigate}  className="btn btn-primary">View </button>
            </MDBCardBody>
            </MDBCard>
          </MDBCol>
          
          <MDBCol>
            <MDBCard className='my-5 bg-glass text-center'>
              <MDBCardBody className='p-5'>
              <MdManageSearch style={{ width: '60px', height: '60px', background:"", color:"rgb(120 54 157)", padding:"12px" }} className='rounded-circle'/><br/>
              Auditor<br/><br/>
               <button onClick={handleauditorNavigate}  className="btn btn-primary">View </button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        

        <MDBCol md="1"></MDBCol></>
: ""}
{role === "dm" ? <>
<MDBCol></MDBCol>
          <MDBCol>  
            <MDBCard className='my-5 bg-glass text-center'>
            <MDBCardBody className='p-5'>
              <BiCloudUpload style={{ width: '60px', height: '60px', background:"", color:"#2d446c", padding:"12px" }} className='rounded-circle'/><br/>
           Data Manager<br/><br/>
             <button onClick={handleuploadNavigate}  className="btn btn-primary">View </button>
            </MDBCardBody>
            </MDBCard>
          </MDBCol>

        <MDBCol></MDBCol>
</> : " "}  
{role === "report" ? <>
<MDBCol></MDBCol>
        <MDBCol>
          <MDBCard className='my-5 bg-glass text-center'>
            <MDBCardBody className='p-5'>
            <BiUser style={{ width: '60px', height: '60px', background:"", color:"#2d446c", padding:"12px" }} className='rounded-circle'/><br/>
             Reviewer<br/><br/>
             <button onClick={handlereviewNavigate}  className="btn btn-primary">View </button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
    
        <MDBCol></MDBCol>
</> : " "}  
{role === "auditor"? <>
<MDBCol></MDBCol>
          <MDBCol>
            <MDBCard className='my-5 bg-glass text-center'>
              <MDBCardBody className='p-5'>
              <MdManageSearch style={{ width: '60px', height: '60px', background:"", color:"#2d446c", padding:"12px" }} className='rounded-circle'/><br/>
              Auditor<br/><br/>
               <button onClick={handleauditorNavigate}  className="btn btn-primary">View </button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

        <MDBCol></MDBCol>
</> : ""}
      </MDBRow>
    </MDBContainer>
    </MDBContainer>
</>
    );
}
export default MFADashboardPage;
